import { useMemo } from 'react'
import { useEffectiveUser } from '@fs/zion-user'
import CacheService, { useCacheService } from '@fs/zion-cache-service'
import { PATRON_BEHAVIOR_SERVICE as SERVICE } from '../../api/serviceNames'
import { preCacheHook } from '../../api/patron-behavior/users'

const cacheConfig = { storeName: 'persons', type: 'session' }
const cacheService = new CacheService({ cache: cacheConfig, strategy: 'cache-and-network' })

export function useUserSegment(): { data: unknown; isLoading: boolean; error: unknown } {
  const { cisId: userCisId } = useEffectiveUser()

  const url = useMemo(() => {
    if (!userCisId) return null
    return `${SERVICE}/users/${userCisId}/segment?includeAncestorCountries=true`
  }, [userCisId])

  const [{ data, loading, error }] = useCacheService(cacheService, url, userCisId, { manual: !userCisId, preCacheHook })

  return { data, isLoading: loading, error }
}
